import {Inject, Injectable, Pipe, PipeTransform} from "@angular/core";
import {APP_CONFIG, AppConfig} from "../../../config/app.config";

@Pipe({
  name: 'priceFormat',
  standalone: true,
})
@Injectable({
  providedIn: 'root'
})
export class PriceFormatPipe implements PipeTransform {
  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig) { }

  transform(value: number, currency?: string): string {
    const newValue = ('' + value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (!currency) {
      return `${newValue}`;
    }
    currency = this.appConfig.currencySigns[currency || 'kzt'];
    return `${newValue} ${currency}`;
  }
}
